import {activeProductProcessing,productProcessingError,type ProductProcessingRecord} from './productProcessing';

export const PRODUCT_SHEET_STALE_MS=20*60*1000;
export interface ProductActivityRecord extends ProductProcessingRecord {
 productSheetAt?:unknown;
 productSheetUrl?:unknown;
 identitySettings?:(NonNullable<ProductProcessingRecord['identitySettings']>&{
  productSheetJob?:{panelId?:string;startedAt:string};
  productSheetFailure?:{message:string;at:string};
 })|null;
}
function sheetStartedAt(row:ProductActivityRecord):number {
 return new Date((row.identitySettings?.productSheetJob?.startedAt??(!row.productSheetUrl?row.productSheetAt:null)??'') as string|Date).getTime();
}
export function productSheetStatus(row:ProductActivityRecord,now=Date.now()):'generating'|'ready'|'idle' {
 const started=sheetStartedAt(row);
 return Number.isFinite(started)&&started>0&&now-started<PRODUCT_SHEET_STALE_MS?'generating':row.productSheetUrl?'ready':'idle';
}
export function productActivityLabel(row:ProductActivityRecord,now=Date.now()):string|null {
 const job=activeProductProcessing(row,now);
 if(job)return job.stage==='queued'?'Queued…':job.stage==='analyzing'?'Analyzing…':'Generating product sheet…';
 if(productSheetStatus(row,now)==='generating')return row.identitySettings?.productSheetJob?.panelId?'Regenerating panel…':'Generating product sheet…';
 return null;
}
export function productActivityError(row:ProductActivityRecord,now=Date.now()):string|null {
 if(productActivityLabel(row,now))return null;
 if(row.identitySettings?.productSheetFailure)return row.identitySettings.productSheetFailure.message;
 if(Number.isFinite(sheetStartedAt(row)))return 'Product sheet generation was interrupted. Please retry.';
 return productProcessingError(row);
}

/** Minimal owner-scoped activity snapshot for saved product choices and brand cards. */
export interface ProductActivityView {productId:number;brandId:number;label:string|null;unavailableReason?:string|null}
